export interface SalesPackDespatchNoteAddRemove {
  salesDespatchNoteId: string;
  salesPackId: string;
}
